import { TButtonSize } from '@r1-frontend/ui-react/components/buttons/button';

const getScaleValueBySize = (size: TButtonSize): number => {
    switch (size) {
        case 'small': return 0.89;
        case 'medium': return 0.9;
        case 'large': return 0.83;
    }
};

export default getScaleValueBySize;
